import axiosInstance from '../plugin/axios';

interface FetchAdminCorporationParams {
  title?: string;
  offset?: number;
  limit?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
}

interface CorporationDtoRx {
  corporationId: number;
  name: string;
  address: string;
  createdAt: string;
}

interface DeleteCorporationDtoTx {
  corporationId: number[]; // 회원 아이디 배열
}

interface CreateCorporationDtoTx {
  name: string;
  address: string;
  sido: string;
  sigungu: string;
  detail: string;
}

interface DetailCorporationDto {
  corporationId: number;
  name: string;
  address: string;
  detail: string;
  sido: string;
  sigungu: string;
}

interface ServerResponse {
  statusCode: number;
  message: string;
}

export const fetchAdminCorporationList = async (
  params: FetchAdminCorporationParams,
): Promise<CorporationDtoRx[]> => {
  try {
    const {
      title,
      offset = 0,
      limit = 10000,
      sortBy = 'createdAt',
      order = 'desc',
    } = params;

    const response = await axiosInstance.get<CorporationDtoRx[]>(
      `/api/admin/corporation`,
      {
        params: {
          title,
          offset,
          limit,
          sortBy,
          order,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchAdminCorporationDelete = async (
  data: DeleteCorporationDtoTx,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.delete<ServerResponse>(
      `/api/admin/corporation`,
      {
        data: data,
      },
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchAdminCorporationRegist = async (
  data: CreateCorporationDtoTx,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.post<ServerResponse>(
      `/api/admin/corporation`,
      data,
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchAdminCorporationDetailData = async (
  corporationId: number,
): Promise<DetailCorporationDto> => {
  try {
    const response = await axiosInstance.get<DetailCorporationDto>(
      `/api/admin/corporation/${corporationId}`,
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchAdminCorporationUpdata = async (
  corporationId: number,
  data: CreateCorporationDtoTx,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.put<ServerResponse>(
      `/api/admin/corporation/${corporationId}`,
      data,
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};
